import "./Shifts.css";
import LateComingEarlyLeavingRules from "./LateComingEarlyLeavingRules";
import WorkingHoursRules from "./WorkingHoursRules";
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Form, InputGroup, Row, Col } from "react-bootstrap";
import ButtonCom from "../../../components/button/button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import { ToastContainer } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import FormControl from "@mui/material/FormControl";
import makeAnimated from "react-select/animated";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";

import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";
import AssignEmployee from "../../../components/AssignEmployee";
import { useDispatch, useSelector } from "react-redux";
import {
  saveShift,
  fetchData,
  initState,
} from "../../../redux/slices/shiftsSlice";
import {
  commonSaveData,
  initCommonState,
  commonGetDataFourth,
} from "../../../redux/slices/commonSlice";
import {
  getStaffListPath,
  updateShiftPath,
  deleteShiftPath,
  assignEmployeeShiftPath,
} from "../../../services/config";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice.js";
import { useGlobalToast } from "../../../stopOldToastGlobally.js";

const animatedComponents = makeAnimated();

// ============= REUSABLE COMPONENTS =============

const NumberInputField = ({
  label,
  value,
  onChange,
  placeholder,
  unit,
  onIncrease,
  onDecrease,
  max = 999,
  min = 0,
  step = 1,
  width = "100px",
  style = {},
  theme = "light"
}) => {
  const isDark = theme === "dark";

  const colors = {
    text: isDark ? "#ffffff" : "#26112c",
    border: isDark ? "rgba(255, 255, 255, 0.2)" : "rgba(74, 42, 82, 0.3)",
    background: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(74, 42, 82, 0.08)",
    buttonBg: isDark ? "rgba(197, 102, 234, 0.2)" : "rgba(74, 42, 82, 0.15)",
    buttonText: isDark ? "#ffffff" : "#4a2a52",
    buttonHover: isDark ? "rgba(102, 126, 234, 0.4)" : "rgba(74, 42, 82, 0.25)",
    buttonDisabled: isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(74, 42, 82, 0.05)",
    buttonTextDisabled: isDark ? "rgba(255, 255, 255, 0.3)" : "rgba(74, 42, 82, 0.3)",
  };

  const displayValue = value !== undefined && value !== null ? value : "";
  const isDecreaseDisabled = parseFloat(value || 0) <= min;
  const isIncreaseDisabled = parseFloat(value || 0) >= max;

  const getUnitDisplay = () => {
    if (unit === "hours" || unit === "hr") return "hr";
    if (unit === "minutes" || unit === "mins") return "min";
    return unit;
  };

  return (
    <div style={{
      ...style,
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      width: width,
      minWidth: width,
      height: "52px",
    }}>
      <label style={{
        fontSize: "12px",
        fontWeight: "600",
        color: colors.text,
        height: "18px",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%"
      }}>
        {label}
      </label>

      <div style={{
        display: "flex",
        alignItems: "center",
        height: "28px",
        border: `1px solid ${colors.border}`,
        borderRadius: "6px",
        backgroundColor: colors.background,
        overflow: "hidden",
        width: "100%"
      }}>
        <button
          type="button"
          onClick={onDecrease}
          disabled={isDecreaseDisabled}
          style={{
            background: isDecreaseDisabled ? colors.buttonDisabled : colors.buttonBg,
            border: "none",
            color: isDecreaseDisabled ? colors.buttonTextDisabled : colors.buttonText,
            fontSize: "16px",
            fontWeight: "bold",
            cursor: isDecreaseDisabled ? "not-allowed" : "pointer",
            padding: "0",
            width: "24px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }}
        >
          <span>−</span>
        </button>

        <Form.Control
          type="text"
          inputMode="decimal"
          value={displayValue}
          onChange={(e) => { if (onChange) onChange(e); }}
          placeholder={placeholder}
          style={{
            width: "calc(100% - 72px)",
            textAlign: "center",
            padding: "0",
            fontSize: "12px",
            height: "100%",
            border: "none",
            backgroundColor: "transparent",
            color: colors.text,
            borderRadius: "0",
            fontWeight: "500",
            outline: "none",
            boxShadow: "none",
            minWidth: "30px"
          }}
          className="universal-input-one"
        />

        <button
          type="button"
          onClick={onIncrease}
          disabled={isIncreaseDisabled}
          style={{
            background: isIncreaseDisabled ? colors.buttonDisabled : colors.buttonBg,
            border: "none",
            color: isIncreaseDisabled ? colors.buttonTextDisabled : colors.buttonText,
            fontSize: "16px",
            fontWeight: "bold",
            cursor: isIncreaseDisabled ? "not-allowed" : "pointer",
            padding: "0",
            width: "24px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }}
        >
          <span>+</span>
        </button>

        <div style={{
          padding: "0 3px",
          fontSize: "11px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.buttonBg,
          color: colors.buttonText,
          minWidth: "28px",
          fontWeight: "600",
          borderLeft: `1px solid ${colors.border}`,
          borderRadius: "0 6px 6px 0",
          flexShrink: 0
        }}>
          {getUnitDisplay()}
        </div>
      </div>
    </div>
  );
};

const ShiftTimingField = ({ row, idx, onChange, onChangeAmPm, theme = "light" }) => {
  const isDark = theme === "dark";
  const colors = {
    text: isDark ? "#ffffff" : "#26112c",
    border: isDark ? "rgba(255, 255, 255, 0.2)" : "rgba(74, 42, 82, 0.3)",
    background: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(74, 42, 82, 0.08)",
    buttonBg: isDark ? "rgba(197, 102, 234, 0)" : "rgba(74, 42, 82, 0.1)",
    buttonText: isDark ? "#ffffff" : "#4a2a52",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px", minWidth: "200px" }}>
      <label style={{ fontSize: "14px", fontWeight: "600", color: colors.text, height: "22px", display: "flex", alignItems: "center" }}>
        Shift Timings
      </label>
      <div style={{ display: "flex", alignItems: "center", gap: "6px", height: "28px" }}>
        <div style={{ display: "flex", alignItems: "center", border: `1px solid ${colors.border}`, borderRadius: "6px", background: colors.background, height: "100%", overflow: "hidden" }}>
          <Form.Control
            value={row.shiftStartTime}
            name="shiftStartTime"
            onChange={(e) => onChange(e, idx)}
            placeholder="10:00"
            required
            style={{ width: "50px", textAlign: "center", padding: "0", fontSize: "14px", height: "100%", border: "none", backgroundColor: "transparent !important", color: colors.text, outline: "none", boxShadow: "none", lineHeight: "1" }}
            className="universal-input-one"
          />
          <div onClick={() => onChangeAmPm(idx, "from")} style={{ cursor: "pointer", padding: "0 4px", fontSize: "14px", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.buttonBg, color: colors.buttonText, minWidth: "36px", fontWeight: "600", borderLeft: `1px solid ${colors.border}`, lineHeight: "1" }}>
            {row.fromAmPm}
          </div>
        </div>
        <div style={{ color: colors.text, fontSize: "14px", fontWeight: "bold", margin: "0 1px" }}>-</div>
        <div style={{ display: "flex", alignItems: "center", border: `1px solid ${colors.border}`, borderRadius: "6px", background: colors.background, height: "100%", overflow: "hidden" }}>
          <Form.Control
            value={row.shiftEndTime}
            name="shiftEndTime"
            onChange={(e) => onChange(e, idx)}
            placeholder="07:00"
            required
            style={{ width: "50px", textAlign: "center", padding: "0", fontSize: "14px", height: "100%", border: "none", backgroundColor: "transparent !important", color: colors.text, outline: "none", boxShadow: "none", lineHeight: "1" }}
            className="universal-input-one"
          />
          <div onClick={() => onChangeAmPm(idx, "to")} style={{ cursor: "pointer", padding: "0 4px", fontSize: "14px", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.buttonBg, color: colors.buttonText, minWidth: "36px", fontWeight: "600", borderLeft: `1px solid ${colors.border}`, lineHeight: "1" }}>
            {row.toAmPm}
          </div>
        </div>
      </div>
    </div>
  );
};

const WeekOffDaysSelector = ({ row, idx, type, onChange, selectIs, customStyles, theme = "light" }) => {
  const isDark = theme === "dark";

  const getDayName = (dayValue) => {
    switch (parseInt(dayValue)) {
      case 1: return "Mon"; case 2: return "Tue"; case 3: return "Wed";
      case 4: return "Thu"; case 5: return "Fri"; case 6: return "Sat";
      case 7: return "Sun"; default: return "";
    }
  };

  const dayName = getDayName(row.days);
  const isAllSelected = row.weekOffDays && row.weekOffDays.some(day => day.value === 5);
  const hasSpecificWeekSelected = row.weekOffDays && row.weekOffDays.some(day => [1, 2, 3, 4].includes(day.value));

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%", gap: "10px", position: "relative" }}>
      <div style={{ width: "130px", minWidth: "130px", height: "28px", position: "relative", flexShrink: 0, zIndex: 1000 }}>
        <FormControl style={{ width: "100%", height: "100%" }}>
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            value={row.weekOffDays || []}
            name={"weekOffDays"}
            isMulti
            placeholder="Select week off"
            hideSelectedOptions={false}
            isClearable={false}
            controlShouldRenderValue={true}
            menuPortalTarget={document.body}
            menuShouldBlockScroll={true}
            menuPosition="fixed"
            options={[
              { label: "1st", value: 1 }, { label: "2nd", value: 2 },
              { label: "3rd", value: 3 }, { label: "Last", value: 4 },
              { label: "All", value: 5 },
            ]}
            menuPlacement="auto"
            onChange={(e) => onChange(e, idx, type)}
            required
            styles={{
              control: (provided) => ({
                ...provided, minHeight: "28px", height: "28px", minWidth: "130px",
                border: (!row.weekOffDays || row.weekOffDays.length === 0) && !selectIs
                  ? "1px solid red"
                  : isDark ? "1px solid rgba(255, 255, 255, 0.3)" : "1px solid rgba(74, 42, 82, 0.3)",
                backgroundColor: isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(255, 255, 255, 0.9)",
                borderRadius: "6px", boxShadow: 'none', cursor: 'pointer', overflow: 'hidden', width: "100%",
                '&:hover': { border: isDark ? "1px solid rgba(255, 255, 255, 0.4)" : "1px solid rgba(74, 42, 82, 0.4)" },
              }),
              container: (provided) => ({ ...provided, width: "100%", position: "relative" }),
              valueContainer: (provided) => ({ ...provided, height: "26px", padding: "0 6px", flexWrap: "nowrap", overflow: "hidden", gap: "4px" }),
              placeholder: (provided) => ({ ...provided, color: isDark ? "rgba(255, 255, 255, 0.6)" : "rgba(17, 17, 17, 0.6)", fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", margin: 0 }),
              multiValue: (provided) => ({ ...provided, backgroundColor: isDark ? "rgba(197, 102, 234, 0.3)" : "rgba(153, 77, 245, 0.2)", borderRadius: "5px", margin: 0, fontSize: "12px", height: "22px", maxWidth: "40px", minWidth: "0", flexShrink: 0 }),
              multiValueLabel: (provided) => ({ ...provided, color: isDark ? "#fff" : "#4a2a52", fontSize: "12px", fontWeight: "600", padding: "1px 4px", lineHeight: "1.2", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }),
              multiValueRemove: (provided) => ({ ...provided, color: isDark ? "#fff" : "#4a2a52", padding: "0 2px", "&:hover": { backgroundColor: isDark ? "rgba(197, 102, 234, 0.5)" : "rgba(153, 77, 245, 0.3)", color: isDark ? "#fff" : "#4a2a52" } }),
              menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
              menu: (provided) => ({ ...provided, zIndex: 9999, backgroundColor: isDark ? "#1e1d2e" : "#fff", border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`, boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", minWidth: "140px", position: "absolute" }),
              menuList: (provided) => ({ ...provided, backgroundColor: isDark ? "#1e1d2e" : "#fff", padding: "4px", maxHeight: "200px" }),
              option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? (isDark ? "rgba(197, 102, 234, 0.3)" : "rgba(153, 77, 245, 0.2)") : state.isFocused ? (isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)") : "transparent", color: isDark ? "#fff" : "#111", fontSize: "13px", padding: "4px 8px", "&:active": { backgroundColor: isDark ? "rgba(197, 102, 234, 0.4)" : "rgba(153, 77, 245, 0.3)" } }),
              input: (provided) => ({ ...provided, fontSize: "13px", margin: 0, padding: 0, width: "1px", minWidth: "1px" }),
              dropdownIndicator: (provided) => ({ ...provided, padding: "4px 6px", color: isDark ? "rgba(255, 255, 255, 0.6)" : "rgba(74, 42, 82, 0.6)" }),
              indicatorsContainer: (provided) => ({ ...provided, height: "26px", width: "28px" }),
              singleValue: (provided) => ({ ...provided, color: isDark ? "#fff" : "#4a2a52", fontSize: "13px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
            }}
          />
        </FormControl>
      </div>
      {row.weekOffDays && row.weekOffDays.length > 0 && hasSpecificWeekSelected && !isAllSelected && (
        <div style={{ display: "flex", alignItems: "center", height: "28px", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", padding: "2px 10px", backgroundColor: isDark ? "rgba(197, 102, 234, 0.2)" : "rgba(74, 42, 82, 0.1)", borderRadius: "5px", border: `1px solid ${isDark ? "rgba(197, 102, 234, 0.2)" : "rgba(74, 42, 82, 0.2)"}`, height: "28px", minWidth: "45px", justifyContent: "center" }}>
            <span style={{ fontSize: "14px", color: isDark ? "#fff" : "#4a2a52", fontWeight: "600", whiteSpace: "nowrap" }}>{dayName}</span>
          </div>
        </div>
      )}
    </div>
  );
};

// ============= MAIN COMPONENT =============

const Shifts = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const state = useSelector((state) => state.shift);
  const commonState = useSelector((state) => state.common);
  const departmentStore = useSelector((state) => state.department);
  const branchStore = useSelector((state) => state.branch);
  const themeStore = useSelector((state) => state.theme);
  const toast = useGlobalToast();
  const lateEarlyRef = useRef(null);
  const workingHrsRef = useRef(null);

  // ── useState hooks ──
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [shiftId, setShiftId] = useState("");
  const [show1, setShow1] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [shiftType, setShiftType] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(true);
  const [editRowData, setEditRowData] = useState(null); // ← ADDED HERE (correct place)
  const [shiftData, setShiftData] = useState({
    userId: user.user_id, shiftId: null, shiftName: "", shiftType: null,
  });
  const [fixedData, setFixedData] = useState([{
    sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1,
    shiftStartTime: "", shiftEndTime: "", breakDuration: "",
    gracePeriod: "", lateByHours: "", weekOff: "",
    fromAmPm: "AM", toAmPm: "AM", weekOffDays: [],
  }]);
  const [flexibleData, setFlexibleData] = useState([{
    sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1,
    grossHours: "", breakDuration: "", lateByHours: "", weekOff: "", weekOffDays: [],
  }]);
  const [isAlert, setIsAlert] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [delId, setDelId] = useState(null);
  const [selectIs, setSelectIs] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [dbState, setDbState] = useState({ branchId: "", departmentId: "" });
  const [gridApi, setGridApi] = useState(null);
  const [outletName, setOutletName] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [preAttType, setPreAttType] = useState(null);
  const [backPath, setBackPath] = useState("/setting/");

  const paginationPageSize = 10;
  const isSelectAll = selectedUsers.length === employeeList.length && employeeList.length > 0;

  const onGridReady = useCallback((params) => { setGridApi(params.api); }, []);

  // ── useEffect: populate child refs when dialog opens in edit mode ──
  // This fires AFTER the dialog is open and child components are mounted
  useEffect(() => {
    if (!open || !isEdit || !editRowData) return;

    const timer = setTimeout(() => {
      const detail = editRowData.details?.[0] || {};

      // ── LateComingEarlyLeavingRules ──────────────────────────
      lateEarlyRef.current?.setData({
        details: [{
          lcp_gracetime_allow:         detail.lcp_gracetime_allow         || "",
          lcp_late_instance_per_month: detail.lcp_late_instance_per_month || "",
          lcp_exceeding_limit:         detail.lcp_exceeding_limit         || "",
          lcp_resetCycle:              detail.lcp_resetCycle              || "monthly",
          elp_gracetime_allow:         detail.elp_gracetime_allow         || "",
          elp_late_instance_per_month: detail.elp_late_instance_per_month || "",
          elp_exceeding_limit:         detail.elp_exceeding_limit         || "",
        }]
      });

      // ── WorkingHoursRules ────────────────────────────────────
      // whr_mandatory_work_hours_minutes = "8:40" → split to hrs + mins
      const parts = (detail.whr_mandatory_work_hours_minutes || "").split(":");
      const mandHrs  = parts[0] || "0";
      const mandMins = parts[1] || "0";

      const halfDayEnabled = !!(
        detail.whr_between_from ||
        detail.whr_between_to   ||
        detail.whr_hours_fullday
      );

      workingHrsRef.current?.setData({
        workHoursPolicy: [{
          mandatoryWorkHours:   mandHrs,
          mandatoryWorkMinutes: mandMins,
          presentCriteria:      detail.whr_present_criteria || "1",
          halfDayCriteria: halfDayEnabled ? [{
            workedLessThanHours: detail.whr_between_from  || "",
            workedBetweenFrom:   detail.whr_between_from  || "",
            workedBetweenTo:     detail.whr_between_to    || "",
            minimumHourFullDay:  detail.whr_hours_fullday || "",
          }] : [],
          absentCriteria: [{
            workedLessThanHours:                detail.whr_ab_less_hours               || "",
            noClockInOrAbsent:                  detail.whr_ab_noClockIn                || "0",
            onlyClockInWithoutClockOutAfterHrs: detail.whr_ab_without_clock_afterhours || "",
          }],
        }]
      });
    }, 200);

    return () => clearTimeout(timer);
  }, [open, isEdit, editRowData]);

  const handleIncrement = (index, fieldName, type = "fixed", maxValue = null, step = 1) => {
    const setter = type === "fixed" ? setFixedData : setFlexibleData;
    setter(prev => {
      const newData = [...prev];
      const currentValue = parseFloat(newData[index][fieldName]) || 0;
      const newValue = currentValue + step;
      if (maxValue !== null && newValue > maxValue) return prev;
      const formattedValue = step % 1 === 0
        ? Math.round(newValue).toString()
        : newValue.toFixed(1).replace(/\.0$/, '');
      newData[index][fieldName] = formattedValue;
      setIsAlert(true);
      return newData;
    });
  };

  const handleDecrement = (index, fieldName, type = "fixed", minValue = 0, step = 1) => {
    const setter = type === "fixed" ? setFixedData : setFlexibleData;
    setter(prev => {
      const newData = [...prev];
      const currentValue = parseFloat(newData[index][fieldName]) || 0;
      const newValue = currentValue - step;
      if (newValue < minValue) return prev;
      const formattedValue = step % 1 === 0
        ? Math.round(newValue).toString()
        : newValue.toFixed(1).replace(/\.0$/, '');
      newData[index][fieldName] = formattedValue;
      setIsAlert(true);
      return newData;
    });
  };

  const handleModalClose1 = () => {
    setShow1(false);
    setSelectedUsers([]);
    setSelectedUsersList([]);
    setSearchQuery("");
    setDbState((pre) => ({ ...pre, branchId: "", departmentId: "" }));
  };

  const handleShow1 = () => setShow1(true);

  const getEmployeeList = useCallback((shiftId) => {
    const path = getStaffListPath(user.user_id, shiftId, dbState.branchId, dbState.departmentId);
    dispatch(commonGetDataFourth(path));
  }, []);

  useEffect(() => {
    const path = getStaffListPath(user.user_id, shiftId, dbState.branchId, dbState.departmentId);
    dispatch(commonGetDataFourth(path));
  }, [dbState.branchId, dbState.departmentId]);

  useEffect(() => {
    if (commonState.commonGetFourthSuccess) {
      if (searchQuery !== "") {
        searchEmployees(searchQuery, commonState.commonGetFourthData);
      } else {
        setEmployeeList(commonState.commonGetFourthData);
        setFilterEmployeeList(commonState.commonGetFourthData);
        const initiallySelected = commonState.commonGetFourthData
          .filter((row) => row.shiftAssignedStatus === "1").map((row) => row.staffId);
        setSelectedUsers(initiallySelected);
        const initiallySelectedUsers = commonState.commonGetFourthData
          .filter((row) => row.shiftAssignedStatus === "1").map((row) => row);
        setSelectedUsersList(initiallySelectedUsers);
      }
      dispatch(initCommonState());
    }
  }, [commonState]);

  const handleAssignId = (data) => {
    setShiftId(data.shiftId);
    setOutletName(data.shiftName);
    getEmployeeList(data.shiftId);
    setTimeout(() => { handleShow1(); }, 100);
  };

  const hasAllWeekOffSelected = (weekOffDays) => {
    if (!weekOffDays || !Array.isArray(weekOffDays)) return false;
    return weekOffDays.some(day => day.value === 5);
  };

  const hasSpecificWeekSelected = (weekOffDays) => {
    if (!weekOffDays || !Array.isArray(weekOffDays)) return false;
    return weekOffDays.some(day => [1, 2, 3, 4].includes(day.value));
  };

  const getShiftList = useCallback(() => {
    dispatch(fetchData(shiftData.userId));
    dispatch(fetchBranchData());
    dispatch(fetchDepartmentData(user.user_id));
  }, []);

  useEffect(() => { getShiftList(); }, []);

  useEffect(() => {
    if (state.shiftGetSuccess) setShiftList(state.shiftGetData);
  }, [state.shiftGetSuccess]);

  const handleClickOpen = () => { setOpen(true); setIsFullScreen(true); };

  const handleClose = () => {
    setIsAlert(false);
    setShiftType("");
    setIsFullScreen(true);
    setEditRowData(null); // ← CLEAR edit data on close
    setShiftData({ ...shiftData, shiftName: "", shiftType: null });
    setFixedData([{
      sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1,
      shiftStartTime: "", shiftEndTime: "", breakDuration: "",
      gracePeriod: "", lateByHours: "", weekOff: "",
      fromAmPm: "AM", toAmPm: "AM", weekOffDays: [],
    }]);
    setFlexibleData([{
      sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1,
      grossHours: "", breakDuration: "", lateByHours: "", weekOff: "", weekOffDays: [],
    }]);
    setValidated(false);
    setOpen(false);
    setTimeout(() => { setIsEdit(false); }, 500);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShiftData({ ...shiftData, [name]: value });
  };

  const validateTimeInput = (value) => {
    if (!/^(\d{0,2})(:?)(\d{0,2})?$/.test(value)) return false;
    const [hourStr, minuteStr] = value.split(":");
    const hour = parseInt(hourStr, 10);
    if (hourStr && (isNaN(hour) || hourStr.length > 2 || hourStr == "00" || hour < 0 || hour > 12)) return false;
    if (minuteStr !== undefined) {
      const minute = parseInt(minuteStr, 10);
      if (minuteStr && (isNaN(minute) || minute < 0 || minute > 59)) return false;
      if (hour === 12 && minute > 0) return false;
    }
    return true;
  };

  const handleFixedTimeChange = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...fixedData];
    if (/^[0-9:]*$/.test(value)) {
      if (validateTimeInput(value)) { newArr[index][name] = value; setFixedData(newArr); }
    }
    setIsAlert(true);
  };

  const handleBreakDuration = (e, index) => {
    const { value } = e.target;
    const newArr = [...fixedData];
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      const numValue = value === '' ? '' : parseFloat(value);
      if (value === '' || numValue <= 120) { newArr[index].breakDuration = value; setFixedData(newArr); }
    }
    setIsAlert(true);
  };

  const handleFixedLateBy = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...fixedData];
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      if (value === '' || parseFloat(value) <= 8) { newArr[index][name] = value; setFixedData(newArr); }
    }
    setIsAlert(true);
  };

  const handleFlexibleLateBy = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...flexibleData];
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      if (value === '' || parseFloat(value) <= 8) { newArr[index][name] = value; setFlexibleData(newArr); }
    }
    setIsAlert(true);
  };

  const handleMandatoryHrs = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...fixedData];
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      if (value === '' || parseFloat(value) <= 12) { newArr[index][name] = value; setFixedData(newArr); }
    }
    setIsAlert(true);
  };

  const handleCheckChange = (e, idx, type) => {
    const { checked } = e.target;
    if (type === "fixed") {
      const newArr = [...fixedData];
      newArr[idx].weekOff = checked ? 1 : 0;
      if (!checked) {
        newArr[idx].shiftStartTime = ""; newArr[idx].shiftEndTime = "";
        newArr[idx].gracePeriod = ""; newArr[idx].lateByHours = "";
        newArr[idx].weekOff = ""; newArr[idx].fromAmPm = "AM";
        newArr[idx].toAmPm = "AM"; newArr[idx].weekOffDays = [];
      }
      setFixedData(newArr);
    }
    if (type === "flexible") {
      const newArr = [...flexibleData];
      newArr[idx].weekOff = checked ? 1 : 0;
      if (!checked) {
        newArr[idx].grossHours = ""; newArr[idx].lateByHours = "";
        newArr[idx].weekOff = ""; newArr[idx].weekOffDays = [];
      }
      setFlexibleData(newArr);
    }
    setIsAlert(true);
  };

  const handleShiftType = (val) => {
    setValidated(false);
    setShiftData({ ...shiftData, shiftType: val });
    if (val == 1) {
      setFlexibleData([{ sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1, grossHours: "", breakDuration: "", lateByHours: "", weekOff: "", weekOffDays: [] }]);
    }
    if (val == 2) {
      setFixedData([{ sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1, shiftStartTime: "", shiftEndTime: "", breakDuration: "", gracePeriod: "", lateByHours: "", weekOff: "", fromAmPm: "AM", toAmPm: "AM", weekOffDays: [] }]);
    }
  };

  const selectDays = (name) => {
    const newArr = [...fixedData];
    newArr[0][name] = newArr[0][name] == 1 ? 0 : 1;
    setFixedData(newArr);
  };

  const changeAmPm = (val, type) => {
    const newArr = [...fixedData];
    if (type === "from") newArr[val].fromAmPm = newArr[val].fromAmPm === "AM" ? "PM" : "AM";
    if (type === "to") newArr[val].toAmPm = newArr[val].toAmPm === "AM" ? "PM" : "AM";
    setFixedData(newArr);
    setIsAlert(true);
  };

  const addFixedDataFields = (val) => {
    const newArr = [...fixedData];
    const index = newArr.findIndex((item) => parseInt(item.id) === parseInt(val));
    if (index !== -1) { newArr.splice(index, 1); }
    else { newArr.push({ id: val, days: val, shiftStartTime: "", shiftEndTime: "", breakDuration: "", gracePeriod: "", lateByHours: "", weekOff: "", fromAmPm: "AM", toAmPm: "AM", weekOffDays: [] }); }
    setFixedData(newArr);
  };

  const selectFlexibleDays = (name) => {
    const newArr = [...flexibleData];
    newArr[0][name] = newArr[0][name] == 1 ? 0 : 1;
    setFlexibleData(newArr);
  };

  const handleFlexibleChange = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...flexibleData];
    if (/^[0-9:]*$/.test(value)) { newArr[index][name] = value; setFlexibleData(newArr); }
  };

  const handleBreakDurationFlexible = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...flexibleData];
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      if (value === '' || parseFloat(value) <= 480) { newArr[index][name] = value; setFlexibleData(newArr); }
    }
    setIsAlert(true);
  };

  const handleMandatoryHrsFlexible = (e, index) => {
    const { name, value } = e.target;
    const newArr = [...flexibleData];
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      if (value === '' || parseFloat(value) <= 24) { newArr[index][name] = value; setFlexibleData(newArr); }
    }
    setIsAlert(true);
  };

  const addFlexibleDataFields = (val) => {
    const newArr = [...flexibleData];
    const index = newArr.findIndex((item) => parseInt(item.id) === parseInt(val));
    if (index !== -1) { newArr.splice(index, 1); }
    else { newArr.push({ id: val, days: val, grossHours: "", breakDuration: "", lateByHours: "", weekOff: "", weekOffDays: [] }); }
    setFlexibleData(newArr);
  };

  const handleWeekOffDaysChange = (e, index, type) => {
    setSelectIs(true);
    if (type === "fixed") {
      const newArr = [...fixedData];
      const existsByValue = e.some((obj) => obj.value === 5);
      newArr[index].weekOffDays = existsByValue ? e.filter((obj) => obj.value === 5) : e;
      setFixedData(newArr);
    }
    if (type === "flexible") {
      const newArr = [...flexibleData];
      const existsByValue = e.some((obj) => obj.value === 5);
      newArr[index].weekOffDays = existsByValue ? e.filter((obj) => obj.value === 5) : e;
      setFlexibleData(newArr);
    }
    setIsAlert(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    const lateEarlyErrors = lateEarlyRef.current?.validate() || [];
    const workingHrsErrors = workingHrsRef.current?.validate() || [];
    const childHasErrors = lateEarlyErrors.length > 0 || workingHrsErrors.length > 0;

    if (form.checkValidity() === false || childHasErrors) {
      setValidated(true);
      setSelectIs(false);
    } else {
      const fixedArr = [];
      const flexArr = [];
      setSelectIs(true);

      fixedData.map((row, idx) => {
        if (idx === 0) {
          const d = [];
          row.sun == 1 ? d.push(7) : null; row.mon == 1 ? d.push(1) : null;
          row.tue == 1 ? d.push(2) : null; row.wed == 1 ? d.push(3) : null;
          row.thi == 1 ? d.push(4) : null; row.fri == 1 ? d.push(5) : null;
          row.sat == 1 ? d.push(6) : null;
          fixedArr.push({ days: d.toString(), shiftStartTime: row.shiftStartTime + " " + row.fromAmPm, shiftEndTime: row.shiftEndTime + " " + row.toAmPm, breakDuration: row.breakDuration, gracePeriod: row.gracePeriod, lateByHours: row.lateByHours, weekOff: row.weekOff });
        } else {
          fixedArr.push({ days: row.days.toString(), shiftStartTime: row.shiftStartTime === "" ? "" : row.shiftStartTime + " " + row.fromAmPm, shiftEndTime: row.shiftEndTime === "" ? "" : row.shiftEndTime + " " + row.toAmPm, breakDuration: row.breakDuration, gracePeriod: row.gracePeriod, lateByHours: row.lateByHours, weekOff: row.weekOff, weekOffDays: row.weekOffDays.map((val) => val.value).toString() });
        }
      });

      flexibleData.map((row, idx) => {
        if (idx === 0) {
          const d = [];
          row.sun == 1 ? d.push(7) : null; row.mon == 1 ? d.push(1) : null;
          row.tue == 1 ? d.push(2) : null; row.wed == 1 ? d.push(3) : null;
          row.thi == 1 ? d.push(4) : null; row.fri == 1 ? d.push(5) : null;
          row.sat == 1 ? d.push(6) : null;
          flexArr.push({ days: d.toString(), grossHours: row.grossHours + " Hours", breakDuration: row.breakDuration + "  Mins", lateByHours: row.lateByHours, weekOff: row.weekOff, weekOffDays: "" });
        } else {
          flexArr.push({ days: row.days.toString(), grossHours: row.grossHours + " Hours", breakDuration: row.breakDuration + "  Mins", lateByHours: row.lateByHours, weekOff: row.weekOff, weekOffDays: row.weekOffDays.map((val) => val.value).toString() });
        }
      });

      const fData = { shiftId: shiftData.shiftId, userId: shiftData.userId, shiftName: shiftData.shiftName, shiftType: shiftData.shiftType, shiftData: fixedArr };
      const fleData = { shiftId: shiftData.shiftId, userId: shiftData.userId, shiftName: shiftData.shiftName, shiftType: shiftData.shiftType, shiftData: flexArr };

      const lateEarlyData = lateEarlyRef.current?.getData() || {};
      const workingHrsData = workingHrsRef.current?.getData() || {};

      let data = {
        ...(shiftData.shiftType == 1 ? fData : fleData),
        ...lateEarlyData,
        ...workingHrsData,
      };

      if (isEdit) {
        dispatch(commonSaveData({ path: updateShiftPath, data }));
      } else {
        dispatch(saveShift(data));
      }
    }
  };

  useEffect(() => {
    if (state.shiftSuccess) {
      handleClose();
      toast.success(state.shiftMessage);
      dispatch(initState());
      setShiftData({ ...shiftData, shiftName: "", shiftType: null });
      setFixedData([{ sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1, shiftStartTime: "", shiftEndTime: "", breakDuration: "", gracePeriod: "", lateByHours: "", weekOff: "", fromAmPm: "AM", toAmPm: "AM", weekOffDays: [] }]);
      setFlexibleData([{ sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1, grossHours: "", breakDuration: "", lateByHours: "", weekOff: "", weekOffDays: [] }]);
      getShiftList();
    }
    if (state.shiftError) {
      toast.error(state.shiftMessage);
      dispatch(initState());
      handleClose();
    }
  }, [state.shiftSuccess, state.shiftError]);

  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleEdit = (row) => {
    setIsAlert(true);
    setIsEdit(true);
    setIsFullScreen(true);

    setShiftData({
      ...shiftData,
      shiftId:   row.shiftId,
      shiftName: row.shiftName,
      shiftType: row.shiftType,
    });

    // shiftType from API is string "1" or "2"
    setShiftType(String(row.shiftType));

    // ── Parse fixed shift details ──────────────────────────────
    if (String(row.shiftType) === "1") {
      const arr = [];
      row.details.forEach((v, idx) => {
        const daysArr = (v.days || "").split(",").map(Number);
        const weekOffDaysParsed = [];
        if (v.weekOffDays) {
          v.weekOffDays.split(",").forEach((el) => {
            const num = Number(el.trim());
            if (!isNaN(num) && num > 0) {
              const label = num === 1 ? "1st" : num === 2 ? "2nd" : num === 3 ? "3rd" : num === 4 ? "Last" : num === 5 ? "All" : "";
              if (label) weekOffDaysParsed.push({ label, value: num });
            }
          });
        }
        const startTimeStr   = v.shiftStartTime || "";
        const endTimeStr     = v.shiftEndTime   || "";
        const startTimeClean = startTimeStr.replace(/(AM|PM)/gi, "").trim();
        const endTimeClean   = endTimeStr.replace(/(AM|PM)/gi, "").trim();
        const fromAmPm       = /PM/i.test(startTimeStr) ? "PM" : "AM";
        const toAmPm         = /PM/i.test(endTimeStr)   ? "PM" : "AM";
        const breakClean     = (v.breakDuration || "").replace(/[^0-9.]/g, "");
        const graceClean     = (v.gracePeriod   || "").replace(/[^0-9.]/g, "");
        const lateClean      = (v.lateByHours   || "").replace(/[^0-9.]/g, "");
        const base = { weekOff: Number(v.weekOff || 0), weekOffDays: weekOffDaysParsed, breakDuration: breakClean, gracePeriod: graceClean, lateByHours: lateClean };
        if (idx === 0) {
          arr.push({ ...base, sun: daysArr.includes(7) ? 1 : 0, mon: daysArr.includes(1) ? 1 : 0, tue: daysArr.includes(2) ? 1 : 0, wed: daysArr.includes(3) ? 1 : 0, thi: daysArr.includes(4) ? 1 : 0, fri: daysArr.includes(5) ? 1 : 0, sat: daysArr.includes(6) ? 1 : 0, shiftStartTime: startTimeClean, shiftEndTime: endTimeClean, fromAmPm, toAmPm });
        } else {
          arr.push({ ...base, id: v.days, days: v.days, shiftStartTime: startTimeClean, shiftEndTime: endTimeClean, fromAmPm, toAmPm });
        }
      });
      setFixedData(arr.length > 0 ? arr : [{ sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1, shiftStartTime: "", shiftEndTime: "", breakDuration: "", gracePeriod: "", lateByHours: "", weekOff: "", fromAmPm: "AM", toAmPm: "AM", weekOffDays: [] }]);

    // ── Parse flexible shift details ───────────────────────────
    } else if (String(row.shiftType) === "2") {
      const arr = [];
      row.details.forEach((v, idx) => {
        const daysArr = (v.days || "").split(",").map(Number);
        const weekOffDaysParsed = [];
        if (v.weekOffDays) {
          v.weekOffDays.split(",").forEach((el) => {
            const num = Number(el.trim());
            if (!isNaN(num) && num > 0) {
              const label = num === 1 ? "1st" : num === 2 ? "2nd" : num === 3 ? "3rd" : num === 4 ? "Last" : num === 5 ? "All" : "";
              if (label) weekOffDaysParsed.push({ label, value: num });
            }
          });
        }
        const grossClean = (v.grossHours    || "").replace(/[^0-9.]/g, "");
        const breakClean = (v.breakDuration || "").replace(/[^0-9.]/g, "");
        const lateClean  = (v.lateByHours   || "").replace(/[^0-9.]/g, "");
        const base = { weekOff: Number(v.weekOff || 0), weekOffDays: weekOffDaysParsed, grossHours: grossClean, breakDuration: breakClean, lateByHours: lateClean };
        if (idx === 0) {
          arr.push({ ...base, sun: daysArr.includes(7) ? 1 : 0, mon: daysArr.includes(1) ? 1 : 0, tue: daysArr.includes(2) ? 1 : 0, wed: daysArr.includes(3) ? 1 : 0, thi: daysArr.includes(4) ? 1 : 0, fri: daysArr.includes(5) ? 1 : 0, sat: daysArr.includes(6) ? 1 : 0 });
        } else {
          arr.push({ ...base, id: v.days, days: v.days });
        }
      });
      setFlexibleData(arr.length > 0 ? arr : [{ sun: 1, mon: 1, tue: 1, wed: 1, thi: 1, fri: 1, sat: 1, grossHours: "", breakDuration: "", lateByHours: "", weekOff: "", weekOffDays: [] }]);
    }

    // Store row → triggers useEffect above after dialog mounts
    setEditRowData(row);
    handleClickOpen();
  };

  const handleDelete = (row) => { setDelId(row.shiftId); handleShow(); };

  const handleDeleteSubmit = () => {
    dispatch(commonSaveData({ path: deleteShiftPath, data: { userId: user?.user_id, shiftId: delId } }));
    handleModalClose();
  };

  useEffect(() => {
    if (commonState.commonSuccess || commonState.commonError) {
      commonState.commonSuccess ? toast.success(commonState.commonMessage) : toast.error(commonState.commonMessage);
      setOpen(false); getShiftList(); setSearchQuery(""); setIsEdit(false);
      dispatch(initCommonState()); handleModalClose(); handleModalClose1();
      setIsAlert(false); setShiftType("");
    }
    if (departmentStore.depGetSuccess) { setDepartmentList(departmentStore.depGetData); dispatch(initDepartState()); }
    if (branchStore.brnGetSuccess) { setBranchList(branchStore.brnGetData); dispatch(initBranchState()); }
  }, [commonState, branchStore, departmentStore]);

const columns = useMemo(
  () => [
    {
      headerName: "Shift Name",
      field: "shiftName",
      flex: 1.2,
      minWidth: 130,
      valueGetter: (params) => params?.data?.shiftName || "-",
    },
    {
      headerName: "Shift Type",
      flex: 0.8,
      minWidth: 100,
      cellRenderer: (params) => {
        const data = params?.data;
        if (!data) return "-";
        return data.shiftType == "1" ? "Fixed" : "Flexible";
      },
    },
    {
      headerName: "Shift Timing",
      autoHeight: true,
      flex: 1.5,
      minWidth: 160,
      cellRenderer: (params) => {
        const details = params?.data?.details;
        if (!details || !Array.isArray(details)) return "-";
        return (
          <ul className="tbl-row-list">
            {details.map((row, idx) => (
              <li key={idx}>
                {row.shiftStartTime && row.shiftEndTime
                  ? `${row.shiftStartTime} - ${row.shiftEndTime}`
                  : "-"}
              </li>
            ))}
          </ul>
        );
      },
    },
    {
      headerName: "Gross Hours",
      autoHeight: true,
      flex: 1,
      minWidth: 110,
      cellRenderer: (params) => {
        const details = params?.data?.details;
        if (!details || !Array.isArray(details)) return "-";
        return (
          <ul className="tbl-row-list">
            {details.map((row, idx) => {
              const grossValue = row?.grossHours;
              
              if (!grossValue || grossValue === "") return <li key={idx}>-</li>;
              
              if (grossValue.includes("Hours")) {
                return <li key={idx}>{grossValue}</li>;
              } else {
                return <li key={idx}>{grossValue} Hours</li>;
              }
            })}
          </ul>
        );
      },
    },
    {
      headerName: "Break Time (Mins)",
      autoHeight: true,
      flex: 1,
      minWidth: 130,
      cellRenderer: (params) => {
        const details = params?.data?.details;
        if (!details || !Array.isArray(details)) return "-";
        return (
          <ul className="tbl-row-list">
            {details.map((row, idx) => {
              const breakValue = row?.breakDuration;
              if (!breakValue || breakValue === "") return <li key={idx}>-</li>;
              
              if (breakValue.includes("Mins")) {
                return <li key={idx}>{breakValue}</li>;
              } else {
                return <li key={idx}>{breakValue} Mins</li>;
              }
            })}
          </ul>
        );
      },
    },
    {
      headerName: "Mandatory work (Hours)",
      autoHeight: true,
      flex: 1.2,
      minWidth: 150,
      cellRenderer: (params) => {
        const details = params?.data?.details;
        if (!details || !Array.isArray(details)) return "-";
        return (
          <ul className="tbl-row-list">
            {details.map((row, idx) => {
              // Check for whr_mandatory_work_hours_minutes first (combined format)
              const mandatoryCombined = row?.whr_mandatory_work_hours_minutes;
              
              if (mandatoryCombined && mandatoryCombined !== "") {
                // Format like "8:30" -> show as "8.5 Hours" or keep as "8:30 Hours"
                return <li key={idx}>{mandatoryCombined} Hours</li>;
              }
              
              // Fallback to gracePeriod
              const mandatoryValue = row?.gracePeriod;
              
              if (!mandatoryValue || mandatoryValue === "") return <li key={idx}>-</li>;
              
              if (mandatoryValue.includes("Hours")) {
                return <li key={idx}>{mandatoryValue}</li>;
              } else {
                return <li key={idx}>{mandatoryValue} Hours</li>;
              }
            })}
          </ul>
        );
      },
    },
    {
      headerName: "If Late By (Hours)",
      autoHeight: true,
      flex: 1,
      minWidth: 130,
      cellRenderer: (params) => {
        const details = params?.data?.details;
        if (!details || !Array.isArray(details)) return "-";
        return (
          <ul className="tbl-row-list">
            {details.map((row, idx) => {
              // Check for whr_ab_less_hours first (this is your "If Late By" field)
              const lateValue = row?.whr_ab_less_hours;
              
              if (lateValue && lateValue !== "" && lateValue !== "0") {
                return <li key={idx}>{lateValue} Hours</li>;
              }
              
              // Fallback to lateByHours
              const lateByValue = row?.lateByHours;
              
              if (!lateByValue || lateByValue === "" || lateByValue === "0") 
                return <li key={idx}>-</li>;
              
              if (lateByValue.includes("Hours")) {
                return <li key={idx}>{lateByValue}</li>;
              } else {
                return <li key={idx}>{lateByValue} Hours</li>;
              }
            })}
          </ul>
        );
      },
    },
    {
      headerName: "Actions",
      width: 160,
      minWidth: 160,
      cellStyle: { display: "flex", alignItems: "center" },
      cellRenderer: (params) => {
        const data = params?.data;
        if (!data) return null;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {HasPermission("Shifts", "create") && (
              <PiUserCheck
                style={{ cursor: "pointer", fontSize: 22 }}
                className="assign-icon"
                onClick={() => handleAssignId(data)}
                title="Assign to Employees"
              />
            )}
            {HasPermission("Shifts", "edit") && (
              <PiPencilSimpleLineBold
                style={{ cursor: "pointer", fontSize: 24 }}
                className="edit-icon"
                onClick={() => handleEdit(data)}
                title="Edit Shift"
              />
            )}
            {HasPermission("Shifts", "delete") && (
              <RiDeleteBinLine
                className="delete-icon"
                style={{ cursor: "pointer", fontSize: 24, color: "#e74c3c" }}
                onClick={() => handleDelete(data)}
                title="Delete Shift"
              />
            )}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ],
  [HasPermission, handleAssignId, handleEdit, handleDelete]
);
  const selectUser = (event, userId, user) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) => isChecked ? [...prevSelected, userId] : prevSelected.filter((id) => id !== userId));
    setSelectedUsersList((prevSelected) => isChecked ? [...prevSelected, user] : prevSelected.filter((u) => u.staffId !== user.staffId));
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) { setSelectedUsers(employeeList.map((row) => row.staffId)); setSelectedUsersList(employeeList.map((row) => row)); }
    else { setSelectedUsers([]); setSelectedUsersList([]); }
  };

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const filteredEmployees = dataList.filter((v) => v.full_name.toLowerCase().includes(val.toLowerCase()) || v.employee_id.toLowerCase().includes(val.toLowerCase()));
    setEmployeeList(filteredEmployees);
    setFilterEmployeeList(dataList);
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    dispatch(commonSaveData({ path: assignEmployeeShiftPath, data: { userId: user.user_id, staffId: selectedUsers.toString(), shiftId } }));
  };

  const handlePreType = (val) => {
    setPreAttType(val);
    if (isAlert) { setConfirm(true); setShiftData({ ...shiftData, shiftType: val }); setShiftType(val); }
    else { setShiftData({ ...shiftData, shiftType: val }); setShiftType(val); }
  };

  const handleFlexChangeYesNo = () => { handleShiftType(2); setPreAttType(null); setConfirm(false); setIsAlert(false); setShiftType("2"); };
  const handleFixedChangeYesNo = () => { handleShiftType(1); setPreAttType(null); setConfirm(false); setIsAlert(false); setShiftType("1"); };
  const cancelChange = () => { setConfirm(false); setPreAttType(null); };
  const handleInputChange = ({ target: { name, value } }) => { setDbState((preState) => ({ ...preState, [name]: value })); };

  useEffect(() => {
    if (localStorage.getItem("emp-redirect")) { setBackPath(localStorage.getItem("emp-redirect")); }
    else { setBackPath("/setting/"); }
  }, []);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 1600, width: "340px", border: "none" }),
    control: (provided) => ({ ...provided, border: "none", boxShadow: "none", backgroundColor: "transparent", color: themeStore.theme === "light" ? "#111" : "#fff" }),
    input: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "#111" : "#fff" }),
    singleValue: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "#111" : "#fff" }),
    placeholder: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "rgba(17, 17, 17, 0.6)" : "rgba(255, 255, 255, 0.6)" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isFocused ? themeStore.theme === "light" ? "#e2e2e4ff" : "#2a2a2a" : "transparent", color: themeStore.theme === "light" ? "#111" : "#fff", cursor: "pointer", border: "none", "&:hover": { backgroundColor: themeStore.theme === "light" ? "#e2e2e4ff" : "#2a2a2a" } }),
    menu: (provided) => ({ ...provided, backgroundColor: themeStore.theme === "light" ? "#fff" : "#1e1d2e", border: "1px solid rgba(255, 255, 255, 0.1)", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }),
    menuList: (provided) => ({ ...provided, backgroundColor: themeStore.theme === "light" ? "#fff" : "#1e1d2e", padding: "10px", maxHeight: "200px" }),
    multiValue: (provided) => ({ ...provided, backgroundColor: themeStore.theme === "light" ? "#e2e2e4ff" : "#2a2a2a" }),
    multiValueLabel: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "#111" : "#fff" }),
    multiValueRemove: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "#111" : "#fff", "&:hover": { backgroundColor: themeStore.theme === "light" ? "#d1d1d1" : "#3a3a3a", color: themeStore.theme === "light" ? "#111" : "#fff" } }),
    indicatorSeparator: (provided) => ({ ...provided, backgroundColor: "rgba(255, 255, 255, 0.2)" }),
    dropdownIndicator: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "#666" : "rgba(255, 255, 255, 0.6)", "&:hover": { color: themeStore.theme === "light" ? "#333" : "#fff" } }),
    clearIndicator: (provided) => ({ ...provided, color: themeStore.theme === "light" ? "#666" : "rgba(255, 255, 255, 0.6)", "&:hover": { color: themeStore.theme === "light" ? "#333" : "#fff" } }),
  };

  const renderDayButtons = (data, idx, row, isFixed) => {
    const days = [
      { key: "sun", label: "S", value: 7 }, { key: "mon", label: "M", value: 1 },
      { key: "tue", label: "T", value: 2 }, { key: "wed", label: "W", value: 3 },
      { key: "thi", label: "T", value: 4 }, { key: "fri", label: "F", value: 5 },
      { key: "sat", label: "S", value: 6 },
    ];
    return days.map((day) => {
      const isDaySelected = idx === 0 ? row[day.key] === 1 : parseInt(row.days) === day.value;
      return (
        <button key={day.key} type="button"
          onClick={() => {
            if (idx === 0) { if (isFixed) selectDays(day.key); else selectFlexibleDays(day.key); }
            if (isFixed) addFixedDataFields(day.value); else addFlexibleDataFields(day.value);
          }}
          style={{ padding: "0", margin: "0", border: `1px solid ${isDaySelected ? "rgba(153, 77, 245, 0.5)" : themeStore.theme === "light" ? "rgba(74, 42, 82, 0.2)" : "rgba(255, 255, 255, 0.2)"}`, borderRadius: "6px", backgroundColor: isDaySelected ? "rgba(153, 77, 245, 0.5)" : themeStore.theme === "light" ? "rgba(74, 42, 82, 0.08)" : "rgba(255, 255, 255, 0.08)", color: isDaySelected ? "#fff" : themeStore.theme === "light" ? "#4a2a52" : "#fff", cursor: "pointer", fontSize: "14px", fontWeight: "600", width: "24px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", lineHeight: "1" }}
        >
          {day.label}
        </button>
      );
    });
  };

  const renderShiftRow = (row, idx, isFixed) => {
    const isAllSelected = hasAllWeekOffSelected(row.weekOffDays);
    const hasSpecificWeeks = hasSpecificWeekSelected(row.weekOffDays);
    const isWeekOffChecked = row.weekOff === 1 || row.weekOff == "1";
    const showFields = idx === 0 || !isWeekOffChecked || (isWeekOffChecked && hasSpecificWeeks && !isAllSelected);

    return (
      <div key={idx} style={{ display: "flex", alignItems: "flex-start", gap: "12px", padding: "10px", border: `1px solid ${themeStore.theme === "light" ? "rgba(74, 42, 82, 0.1)" : "rgba(255, 255, 255, 0.1)"}`, borderRadius: "6px", marginBottom: "8px", backgroundColor: themeStore.theme === "light" ? "rgba(74, 42, 82, 0.02)" : "rgba(255, 255, 255, 0.02)", flexWrap: "nowrap", width: "100%", boxSizing: "border-box", minHeight: "70px" }}>
        <div style={{ flexShrink: 0, height: "52px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <label style={{ fontSize: "14px", fontWeight: "600", color: themeStore.theme === "light" ? "#111" : "#fff", height: "22px", display: "flex", alignItems: "center" }}>Days</label>
          <div style={{ display: "flex", alignItems: "center", gap: "4px", height: "28px" }}>
            {renderDayButtons(isFixed ? fixedData : flexibleData, idx, row, isFixed)}
          </div>
        </div>

        {idx !== 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: "6px", flexShrink: 0, minWidth: isWeekOffChecked ? "180px" : "90px", height: "52px", justifyContent: "space-between" }}>
            <label style={{ fontSize: "14px", fontWeight: "600", color: themeStore.theme === "light" ? "#111" : "#fff", height: "22px", display: "flex", alignItems: "center" }}>Week Off</label>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", height: "28px" }}>
              <div onClick={() => { handleCheckChange({ target: { checked: !(row.weekOff === 1 || row.weekOff == "1") } }, idx, isFixed ? "fixed" : "flexible"); }}
                style={{ width: "18px", height: "22px", border: `2px solid ${themeStore.theme === "light" ? "#4a2a52" : "#667eea"}`, borderRadius: "5px", backgroundColor: isWeekOffChecked ? (themeStore.theme === "light" ? "#4a2a52" : "#667eea") : "transparent", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", flexShrink: 0 }}>
                {isWeekOffChecked && <span style={{ color: "#fff", fontSize: "14px", fontWeight: "bold", lineHeight: "1" }}>✓</span>}
              </div>
              {isWeekOffChecked && (
                <div style={{ width: "auto", display: "flex", alignItems: "center", gap: "6px", flexGrow: 1 }}>
                  <WeekOffDaysSelector row={row} idx={idx} type={isFixed ? "fixed" : "flexible"} onChange={handleWeekOffDaysChange} selectIs={selectIs} customStyles={customStyles} theme={themeStore.theme} />
                </div>
              )}
            </div>
          </div>
        )}

        {showFields && (
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "nowrap", flexShrink: 0, height: "60px", justifyContent: "center" }}>
            {isFixed ? (
              <>
                <div style={{ flexShrink: 0, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <ShiftTimingField row={row} idx={idx} onChange={handleFixedTimeChange} onChangeAmPm={changeAmPm} theme={themeStore.theme} />
                </div>
                <NumberInputField label="Break Duration" value={row.breakDuration} onChange={(e) => handleBreakDuration(e, idx)} placeholder="60" unit="mins" onIncrease={() => handleIncrement(idx, "breakDuration", "fixed", 120, 15)} onDecrease={() => handleDecrement(idx, "breakDuration", "fixed", 0, 15)} max={120} min={0} step={15} width="120px" theme={themeStore.theme} />
              </>
            ) : (
              <NumberInputField label="Break Duration" value={row.breakDuration} onChange={(e) => handleBreakDurationFlexible(e, idx)} placeholder="120" unit="mins" onIncrease={() => handleIncrement(idx, "breakDuration", "flexible", 120, 15)} onDecrease={() => handleDecrement(idx, "breakDuration", "flexible", 0, 15)} max={120} min={0} step={15} width="120px" theme={themeStore.theme} />
            )}
          </div>
        )}
      </div>
    );
  };

  // ── KEY FIX: Child components rendered DIRECTLY in JSX (not via a function) ──
  // This prevents remounting on every render, keeping refs stable.
  // They are always rendered when the dialog is open; visibility is controlled by
  // the parent shiftType condition wrapping them in the DialogContent below.

  return (
    <div className="SettingBody" style={{ position: "fixed", width: "calc(100%)", height: "calc(100vh - 50px)", marginTop: "-25px" }}>
      <AssignEmployee
        isOpen={show1} closeOpenDialog={handleModalClose1} submitData={handleAssignShiftSubmit}
        isSelectAll={isSelectAll} SelectAll={SelectAll} selectedUsersList={selectedUsersList}
        employeeList={employeeList} selectedUsers={selectedUsers} selectUser={selectUser}
        branchList={branchList} departmentList={departmentList} state={dbState}
        handleInputChange={handleInputChange} getData={""} searchQuery={searchQuery}
        searchEmployees={searchEmployees} outletName={outletName} dataList={filterEmployeeList}
      />

      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton><Modal.Title>Delete Shift</Modal.Title></Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button style={{ backgroundColor: "gray", color: "#fff", marginRight: "5px" }} onClick={handleModalClose}>Cancel</Button>
          <Button style={{ backgroundColor: "red", color: "#fff" }} onClick={handleDeleteSubmit}>Delete</Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" autoClose={2000} className="toast-custom" />
      
      <div className="SettingBody-card mt-1" style={{ width: "100%", padding: "0 60px" }}>
        <div className="Branches-body" style={{ borderRadius: "7px", backgroundColor: "transparent" }}>
          <Widgets
            icon={<WidgetsIcon icon={<Link to={backPath} className="icon-color"><ArrowBackIcon /></Link>} title="Company Shifts" />}
            button={HasPermission("Shifts", "create") && (
              <ButtonCom type={"button"} class_name={"border-radius-8px universal-btn"} text={"Add Shift"} url_or_onclick={handleClickOpen} icon={<AddIcon style={{ position: "relative", top: "-2px" }} />} width={""} />
            )}
            body={
              <>
                <div className="ag-theme-quartz custom-grid" style={{ height: "calc(100vh - 210px)", width: "100%" }}>
                  <AgGridReact rowData={Array.isArray(shiftList) ? shiftList : []} columnDefs={columns} omLayout="autoHeight" pagination={true} paginationPageSize={paginationPageSize} onGridReady={onGridReady} />
                </div>
                <div className="d-flex align-items-center justify-content-between custom-pagination">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                </div>
              </>
            }
          />

          <Dialog
            fullScreen={true} open={open} onClose={handleClose}
            sx={{
              "& .MuiDialog-paper": { margin: 0, width: "100vw", height: "100vh", maxWidth: "100vw", maxHeight: "100vh", borderRadius: 0, backgroundColor: themeStore.theme === "light" ? "#ffffff" : "#1e1d2e", backgroundImage: "none", overflow: "hidden", display: "flex", flexDirection: "column" },
              "& .MuiDialogContent-root": { flex: "1 1 auto", overflowY: "auto", overflowX: "hidden", minHeight: 0, padding: "24px" },
              "& .MuiDialogActions-root": { flexShrink: 0, padding: "16px 24px" },
              "& .MuiBackdrop-root": { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
          >
            <DialogTitle
              style={{ backgroundColor: themeStore.theme === "light" ? "#ffffff" : "#1e1d2e", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", flexShrink: 0, borderBottom: `1px solid ${themeStore.theme === "light" ? "#e0e0e0" : "rgba(255, 255, 255, 0.1)"}` }}
              sx={{ fontSize: "18px !important", fontWeight: "700 !important", color: `${themeStore.theme === "light" ? "#111111" : "#ffffff"} !important` }}
            >
              <span style={{ color: themeStore.theme === "light" ? "#111111" : "#ffffff", fontSize: "18px", fontWeight: "700" }}>{isEdit ? "Update Shift" : "Add New Shift"}</span>
              <Button onClick={handleClose} style={{ minWidth: "auto", padding: "8px", color: themeStore.theme === "light" ? "#666" : "#fff", backgroundColor: "transparent", border: "none", fontSize: "20px", cursor: "pointer" }}>✕</Button>
            </DialogTitle>

            <Form noValidate validated={validated} onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 65px)", overflow: "hidden", backgroundColor: themeStore.theme === "light" ? "#ffffff" : "#1e1d2e" }}>
              <DialogContent style={{ flex: 1, overflowY: "auto", overflowX: "hidden", padding: "24px", minHeight: 0, backgroundColor: themeStore.theme === "light" ? "#ffffff" : "#1e1d2e" }}>

                {/* Shift Name */}
                <Row>
                  <Col sm="4">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ color: themeStore.theme === "light" ? "#111" : "#fff" }}>
                        Shift Name <span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control type="text" name="shiftName" value={shiftData.shiftName} placeholder="Enter Shift Name" onChange={handleChange} required readOnly={isEdit} className="universal-input-one"
                        style={{ backgroundColor: themeStore.theme === "light" ? "#fff" : "rgba(255, 255, 255, 0.05)", color: themeStore.theme === "light" ? "#111" : "#fff", border: themeStore.theme === "light" ? "1px solid #ccc" : "1px solid rgba(255, 255, 255, 0.3)" }}
                      />
                      <Form.Control.Feedback type="invalid">Please provide valid shift name.</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Shift Type */}
                <Row className="mt-3">
                  <Form.Label style={{ color: themeStore.theme === "light" ? "#111" : "#fff" }}>Select Shift Type</Form.Label>
                  <Col sm={6} style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <div className="radio-div-containe" onClick={() => handlePreType("1")}>
                      <div className={shiftType == "1" ? "radio-btn active" : "radio-btn"}><div className="center-circle"></div></div>
                      <span style={{ color: themeStore.theme === "light" ? "#111" : "#fff" }}>Fixed shift timing</span>
                    </div>
                    <div className="radio-div-containe" onClick={() => handlePreType("2")}>
                      <div className={shiftType == "2" ? "radio-btn active" : "radio-btn"}><div className="center-circle"></div></div>
                      <span style={{ color: themeStore.theme === "light" ? "#111" : "#fff" }}>Flexible work hours</span>
                    </div>
                  </Col>
                </Row>

                {/* Fixed Shift Rows */}
                {shiftData.shiftType == "1" && (
                  <Row className="mt-3">
                    <Col sm="12">
                      {fixedData.map((row, idx) => renderShiftRow(row, idx, true))}
                      {/* ── Additional Rules — rendered inline, NOT via a function ── */}
                      <div style={{ marginTop: "25px", padding: "15px", border: `2px dashed ${themeStore.theme === "light" ? "rgba(74, 42, 82, 0.2)" : "rgba(255, 255, 255, 0.2)"}`, borderRadius: "10px", backgroundColor: themeStore.theme === "light" ? "rgba(74, 42, 82, 0.02)" : "rgba(255, 255, 255, 0.02)" }}>
                        <h5 style={{ color: themeStore.theme === "light" ? "#4a2a52" : "#fff", marginBottom: "15px", fontSize: "16px", fontWeight: "600", paddingLeft: "5px" }}>Additional Rules (Common for all days)</h5>
                        <LateComingEarlyLeavingRules ref={lateEarlyRef} theme={themeStore.theme} shiftType="fixed" />
                        <div style={{ marginTop: "15px" }}>
                          <WorkingHoursRules ref={workingHrsRef} theme={themeStore.theme} shiftType="fixed" />
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}

                {/* Flexible Shift Rows */}
                {shiftData.shiftType == "2" && (
                  <Row className="mt-3">
                    <Col sm="12">
                      {flexibleData.map((row, idx) => renderShiftRow(row, idx, false))}
                      {/* ── Additional Rules — rendered inline, NOT via a function ── */}
                      <div style={{ marginTop: "25px", padding: "15px", border: `2px dashed ${themeStore.theme === "light" ? "rgba(74, 42, 82, 0.2)" : "rgba(255, 255, 255, 0.2)"}`, borderRadius: "10px", backgroundColor: themeStore.theme === "light" ? "rgba(74, 42, 82, 0.02)" : "rgba(255, 255, 255, 0.02)" }}>
                        <h5 style={{ color: themeStore.theme === "light" ? "#4a2a52" : "#fff", marginBottom: "15px", fontSize: "16px", fontWeight: "600", paddingLeft: "5px" }}>Additional Rules (Common for all days)</h5>
                        <LateComingEarlyLeavingRules ref={lateEarlyRef} theme={themeStore.theme} shiftType="flexible" />
                        <div style={{ marginTop: "15px" }}>
                          <WorkingHoursRules ref={workingHrsRef} theme={themeStore.theme} shiftType="flexible" />
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}

              </DialogContent>

              <DialogActions style={{ backgroundColor: themeStore.theme === "light" ? "#fff" : "#1e1d2e", borderTop: themeStore.theme === "light" ? "1px solid #e0e0e0" : "1px solid rgba(255, 255, 255, 0.1)", padding: "12px 24px", flexShrink: 0 }}>
                <Button onClick={handleClose} style={{ fontWeight: "300", fontSize: "14px", height: "38px", width: "120px", backgroundColor: themeStore.theme === "light" ? "#f5f5f5" : "#2a2a2a", color: themeStore.theme === "light" ? "#111" : "#fff", border: themeStore.theme === "light" ? "1px solid #ccc" : "1px solid rgba(255, 255, 255, 0.2)" }} className="secondary-btn border-radius-8px">
                  Cancel
                </Button>
                <Button variant="contained" color="info" type="submit" style={{ fontWeight: "300", height: "38px", width: "120px", backgroundColor: themeStore.theme === "light" ? "#1976d2" : "#667eea", color: "#fff" }} className="universal-btn border-radius-8px">
                  {isEdit ? "Update" : "Save"}
                </Button>
              </DialogActions>
            </Form>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default Shifts;